import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_SUBSCRIBE_PLAN, FETCH_ALL_SUBSCRIPTION_PLANS, API_ACTIVATE_SUBSCRIPTION, FETCH_CURRENT_USER_SUBSCRIPTION, API_CREATE_ENTITY } from 'src/@core/services/util/api.endpoints';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlansService {

  constructor(
    private http: HttpClient
  ) { }

  // fetch all subscription plans
  fetchAllSubscriptionPlans() {
    let url = FETCH_ALL_SUBSCRIPTION_PLANS;
    return this.http.get<any>(url);
  }

  // subscribe plan
  sendRequestForSubscription(params: any) {
    const url = API_SUBSCRIBE_PLAN;
    return this.http.post<any>(url, params);
  }

  // activate subscription
  activateSubscription(subscriptionId: string, subscriptionPaymentRequest: any) {
    const url = API_ACTIVATE_SUBSCRIPTION + '/' + subscriptionId;
    return this.http.put(url, subscriptionPaymentRequest);
  }

  // fetch subscription details of logged in user
  fetchCurrentUserSubscription() {
    let url = FETCH_CURRENT_USER_SUBSCRIPTION;
    return this.http.get<any>(url);
  }

  getEntityDetails(entityId: string) {
    const url = API_CREATE_ENTITY + '/' + entityId;
    return this.http.get<any>(url);
  }
}
